/* Pressure LA theme behavior */
(function () {
  'use strict';

  var root = document.documentElement;
  var cfg = window.PressureTheme || {};
  var money = function (cents) {
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2);
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var asset = function (name) { return (cfg.assets && cfg.assets[name]) || ''; };

  /* ---------- Flavor styling by product handle ---------- */
  var FLAVORS = {
    'black-cherry-hybrid': { color: '#C0408A', vibe: 'classic sweet black cherry', gummy: 'none' },
    'watermelon-hybrid': { color: '#E0303F', vibe: 'straight watermelon', gummy: 'hue-rotate(14deg) saturate(1.25)' },
    'grape-hybrid': { color: '#B83FC0', vibe: 'vine-ripe grape', gummy: 'hue-rotate(-42deg)' },
    'blue-razz-hybrid': { color: '#2FA8E0', vibe: 'bold, tart blue raspberry', gummy: 'blue' },
    'mango-hybrid': { color: '#E8A51A', vibe: 'fresh, juicy mango', gummy: 'hue-rotate(78deg) saturate(1.15)' },
    'pink-lemonade-hybrid': { color: '#F28FCB', vibe: 'fruity pink lemonade', gummy: 'hue-rotate(6deg) brightness(1.18)' },
    'blue-razz-haze-sativa': { color: '#2A8FD6', vibe: 'berry · blueberry · sweet' },
    'pineapple-og-sativa': { color: '#E8862A', vibe: 'pineapple · tropical · citrus' },
    'super-lemon-cookies-sativa': { color: '#E6D21E', vibe: 'lemon · citrus · lime' },
    'rose-gold-rackz-sativa': { color: '#B5546A', vibe: 'floral · fruity · gas' },
    'sour-bandana-indica': { color: '#2E9E4A', vibe: 'earthy · diesel · citrus' },
    'guava-cookies-sativa': { color: '#E0567E', vibe: 'butter · fruit · nutty' },
    'durban-biscotti-sativa': { color: '#C08A2E', vibe: 'sweet · chocolate · gas' },
    'peach-pop-sativa': { color: '#E07A6A', vibe: 'earthy · fruity · sweet' },
    'berry-sundae-sativa': { color: '#A040B0', vibe: 'berries · cherry · sweet' }
  };

  /* ---------- Product data ---------- */
  var products = {};
  var order = [];
  document.querySelectorAll('script[data-pr-products]').forEach(function (el) {
    try {
      JSON.parse(el.textContent).forEach(function (p) {
        if (!p || !p.title) return;
        if (!products[p.handle]) order.push(p.handle);
        products[p.handle] = p;
      });
    } catch (e) { /* ignore malformed block */ }
  });

  function lineOf(p) {
    var type = (p.type || '').toLowerCase();
    var vendor = (p.vendor || '').toLowerCase();
    if (type.indexOf('gumm') > -1) return 'gummies';
    if (type.indexOf('cart') > -1) return 'resin';
    if (vendor.indexOf('rosin') > -1) return 'rosin';
    return 'other';
  }
  var LINE_LABEL = { gummies: 'Honcho Gummies', rosin: 'Live Rosin Disposable', resin: 'Live Resin Cart', other: 'Disposable' };

  function parts(p) {
    var bits = (p.title || '').split('|').map(function (s) { return s.trim(); });
    return { name: bits[0] || p.title, strain: bits[1] || '' };
  }

  function anatomy(p) {
    var line = lineOf(p);
    var f = FLAVORS[p.handle] || {};
    var vibe = f.vibe || '';
    if (line === 'gummies') {
      var blue = f.gummy === 'blue';
      return {
        title: 'Inside the bag',
        img: blue ? asset('gummiesBlue') : asset('gummies'),
        filter: blue ? 'none' : (f.gummy || 'none'),
        alt: parts(p).name + ' Honcho gummies',
        spots: [
          { x: 66, y: 27, label: 'Count', value: '20 pieces', note: 'Twenty gummies in every bag.' },
          { x: 37, y: 39, label: 'Per piece', value: '800mg', note: 'Each gummy carries 800mg.' },
          { x: 61, y: 57, label: 'Per bag', value: '16,000mg', note: '20 pieces × 800mg — the full Honcho.' },
          { x: 34, y: 72, label: 'Blend', value: 'D9 & THCP', note: 'The active cannabinoids in Honcho.' }
        ]
      };
    }
    if (line === 'rosin') {
      return {
        title: 'Inside the device',
        img: asset('disposable'), filter: 'none',
        alt: 'Pressure live rosin disposable',
        spots: [
          { x: 51, y: 41, label: 'Extract', value: 'Live rosin', note: 'THC-A live rosin' + (vibe ? ' — ' + vibe : '') + '.' },
          { x: 40, y: 28, label: 'Capacity', value: '3.5 grams', note: 'A full 3.5g in every device.' },
          { x: 61, y: 13, label: 'Mouthpiece', value: 'Dual airflow', note: 'Two airflow paths for a smoother draw.' },
          { x: 60, y: 68, label: 'Power', value: 'Variable voltage', note: 'Three heat settings: high, medium, low.' },
          { x: 38, y: 74, label: 'Screen', value: 'LED display', note: 'Battery and setting at a glance.' },
          { x: 19, y: 85, label: 'Charging', value: 'USB-C', note: 'Fast charging over USB-C.' }
        ]
      };
    }
    if (line === 'resin') {
      return {
        title: 'Inside the cart',
        img: asset('cart'), filter: 'none',
        alt: 'Pressure live resin 510 cartridge',
        spots: [
          { x: 47, y: 45, label: 'Extract', value: 'Live resin', note: 'Pressure live resin THC-A blend' + (vibe ? ' — ' + vibe : '') + '.' },
          { x: 57, y: 33, label: 'Capacity', value: '3.5 grams', note: '3.5g net weight per cartridge.' },
          { x: 64, y: 57, label: 'Tank', value: 'Glass', note: 'Glass tank construction.' },
          { x: 30, y: 70, label: 'Base', value: 'Concave', note: 'Concave tank bottom.' },
          { x: 34, y: 83, label: 'Thread', value: '510', note: 'Standard 510 connection — fits most batteries.' }
        ]
      };
    }
    return null;
  }

  /* ---------- Cart ---------- */
  var toastEl = document.querySelector('[data-pr-toast]');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 2400);
  }
  function setCount(n) {
    document.querySelectorAll('[data-pr-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function refreshCart() {
    return fetch((cfg.routes && cfg.routes.cart) ? cfg.routes.cart + '.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c; })
      .catch(function () {});
  }
  function addToCart(variantId, qty, label) {
    var url = (cfg.routes && cfg.routes.cartAdd) ? cfg.routes.cartAdd + '.js' : '/cart/add.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to bag');
        return data;
      });
    }).then(function () {
      // Instant confirmation; Rebuy Smart Cart (if installed) opens its drawer once its cart module has loaded.
      toast((label || 'Added') + (qty > 1 ? ' × ' + qty : '') + ' — in the bag');
      var rebuy = window.Rebuy;
      if (rebuy && rebuy.Cart && rebuy.SmartCart && typeof rebuy.SmartCart.show === 'function') {
        try {
          var showDrawer = function () { try { rebuy.SmartCart.show(); } catch (e) { /* drawer unavailable */ } };
          var p = rebuy.Cart.fetchCart && rebuy.Cart.fetchCart();
          if (p && typeof p.then === 'function') p.then(showDrawer, showDrawer); else showDrawer();
        } catch (e) { /* keep the toast only */ }
      }
      return refreshCart();
    }).catch(function (err) { toast(err.message || 'Could not add to bag'); throw err; });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-pr-add]');
    if (add) {
      e.preventDefault();
      addToCart(add.getAttribute('data-pr-add'), 1, add.getAttribute('data-pr-label')).catch(function () {});
    }
  });

  /* ---------- Menu tabs ---------- */
  document.querySelectorAll('[data-pr-menu]').forEach(function (menu) {
    var tabs = menu.querySelectorAll('[data-pr-tab]');
    var cards = menu.querySelectorAll('[data-pr-line]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-pr-tab');
        tabs.forEach(function (t) { t.setAttribute('aria-pressed', String(t === tab)); });
        cards.forEach(function (c) { c.hidden = !(key === 'all' || c.getAttribute('data-pr-line') === key); });
      });
    });
  });
  document.addEventListener('click', function (e) {
    var jump = e.target.closest('[data-pr-jump-tab]');
    if (!jump) return;
    var key = jump.getAttribute('data-pr-jump-tab');
    var tab = document.querySelector('[data-pr-tab="' + key + '"]');
    if (tab) {
      e.preventDefault();
      tab.click();
      var menu = tab.closest('[data-pr-menu]');
      if (menu) menu.scrollIntoView({ behavior: 'smooth' });
    }
  });

  /* ---------- Lightbox ---------- */
  var lb = document.querySelector('[data-pr-lightbox]');
  var lbBody = lb && lb.querySelector('[data-pr-lb-body]');
  var lastFocus = null;
  var state = { handle: null, qty: 1, spot: 0, locked: false, timer: null };
  var reviewCfg = lb ? {
    rating: lb.getAttribute('data-review-rating') || '',
    count: lb.getAttribute('data-review-count') || '',
    label: lb.getAttribute('data-review-label') || '',
    dist: (lb.getAttribute('data-review-dist') || '').split(',').map(function (s) { return s.trim(); })
  } : {};

  var STAR = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9L12 3z"></path></svg>';
  var CHEV = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 9l6 6 6-6"></path></svg>';

  function render() {
    var p = products[state.handle];
    if (!p || !lbBody) return;
    var line = lineOf(p);
    var nm = parts(p);
    var f = FLAVORS[p.handle] || {};
    var accent = 'var(--pr-accent)';
    var off = p.compare > p.price ? Math.round((1 - p.price / p.compare) * 100) : 0;
    var related = order.filter(function (h) {
      var q = products[h];
      return h !== p.handle && q.available && lineOf(q) === line;
    }).slice(0, 4);
    var an = anatomy(p);

    var html = '';
    html += '<div class="pr-pd">';
    html += '<div class="pr-pd__media"><div class="pr-pd__img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(nm.name) + '" width="900" height="900">' : '') + '</div>';
    if (related.length) {
      html += '<div class="pr-pd__related"><h3>Also on deck</h3><div class="pr-pd__related-grid">';
      related.forEach(function (h) {
        var q = products[h];
        html += '<button type="button" class="pr-mini" data-pr-open="' + esc(h) + '" aria-label="View ' + esc(parts(q).name) + '">' +
          (q.image ? '<img src="' + esc(q.image) + '" alt="" width="48" height="48" loading="lazy">' : '') +
          '<span>' + esc(parts(q).name) + '<strong>' + money(q.price) + '</strong></span></button>';
      });
      html += '</div></div>';
    }
    html += '</div>';

    html += '<div class="pr-pd__info">';
    html += '<div><p class="pr-pd__line">' + esc(LINE_LABEL[line]) + (nm.strain ? ' · ' + esc(nm.strain) : '') + '</p>';
    html += '<h2 id="pr-lb-title" class="pr-display pr-pd__name">' + esc(nm.name) + '</h2>';
    if (f.vibe) html += '<p class="pr-serif pr-pd__vibe">' + esc(f.vibe) + '</p>';
    html += '</div>';
    if (p.rating) html += '<a class="pr-pd__rating" href="#pr-lb-reviews">' + STAR + '<span>' + esc(p.rating) + ' / 5 · Read reviews</span></a>';
    html += '<div class="pr-pd__price">' + (off ? '<s>' + money(p.compare) + '</s>' : '') + '<strong>' + money(p.price) + '</strong>' + (off ? '<span class="pr-pd__off">-' + off + '% off</span>' : '') + '</div>';
    if (p.available && p.variant) {
      html += '<div class="pr-pd__buy"><div class="pr-qty" role="group" aria-label="Quantity">' +
        '<button type="button" data-pr-qty="-1" aria-label="Decrease quantity">−</button>' +
        '<output aria-live="polite" data-pr-qty-out>' + state.qty + '</output>' +
        '<button type="button" data-pr-qty="1" aria-label="Increase quantity">+</button></div>' +
        '<button type="button" class="pr-btn pr-btn--solid pr-pd__add" data-pr-lb-add>Add to bag — <span data-pr-total>' + money(p.price * state.qty) + '</span></button></div>';
      html += '<button type="button" class="pr-pd__now" data-pr-lb-now>Buy it now</button>';
    } else {
      html += '<p class="pr-mono" style="margin:0;color:var(--pr-muted)">Sold out — in the vault.</p>';
    }
    html += '<div class="pr-acc">';
    html += '<details open><summary>Description ' + CHEV + '</summary><div class="pr-acc__body">' + (p.description || '') + '</div></details>';
    html += '<details><summary>Lab results ' + CHEV + '</summary><div class="pr-acc__body"><p>Third-party tested. ' + (cfg.coaUrl ? '<a href="' + esc(cfg.coaUrl) + '">View the COAs</a>.' : '') + '</p></div></details>';
    html += '<details><summary>Shipping &amp; age ' + CHEV + '</summary><div class="pr-acc__body"><p>Fast, discreet shipping. 21+ only — age is verified at checkout.</p></div></details>';
    html += '</div>';
    html += '<p style="margin:0"><a href="' + esc(p.url) + '" class="pr-mono" style="font-size:11px">View full product page</a></p>';
    html += '</div></div>';

    if (an) {
      html += '<section class="pr-section" aria-labelledby="pr-lb-up"><div class="pr-section__head"><div>' +
        '<p class="pr-eyebrow" style="margin-bottom:8px;font-size:12px">Up close</p>' +
        '<h3 id="pr-lb-up" class="pr-display pr-section__title">' + esc(an.title) + '</h3></div>' +
        '<p class="pr-serif" style="margin:0;font-size:22px;color:var(--pr-muted)">Tap a point to take a closer look.</p></div>';
      html += '<div class="pr-up"><div class="pr-up__stage" data-pr-stage><div class="pr-up__frame" data-pr-frame>' +
        '<span class="pr-up__glow" aria-hidden="true" style="background: radial-gradient(circle, ' + esc(f.color || '#FFD100') + ' 0%, rgba(0,0,0,0) 68%)"></span>' +
        '<div class="pr-up__float"><div class="pr-up__zoom" data-pr-zoom>' +
        '<img src="' + esc(an.img) + '" alt="' + esc(an.alt) + '" style="filter:' + esc(an.filter) + '" width="1000" height="1000">';
      an.spots.forEach(function (s, i) {
        html += '<button type="button" class="pr-spot" data-pr-spot="' + i + '" aria-pressed="false" aria-label="' + esc(s.label + ': ' + s.value) + '" style="left:' + s.x + '%;top:' + s.y + '%">' +
          '<span class="pr-spot__ring" aria-hidden="true"></span><span class="pr-spot__dot" aria-hidden="true"></span></button>';
      });
      html += '</div></div></div></div>';
      html += '<div class="pr-up__panel"><div data-pr-readout></div><ul class="pr-up__list">';
      an.spots.forEach(function (s, i) {
        html += '<li><button type="button" class="pr-up__row" data-pr-spot="' + i + '" aria-pressed="false"><span>' + String(i + 1).padStart(2, '0') + ' · ' + esc(s.label) + '</span><span>' + esc(s.value) + '</span></button></li>';
      });
      html += '</ul></div></div></section>';
    }

    if (line === 'gummies' && reviewCfg.rating) {
      var labels = ['5', '4', '3', '2', '1'];
      html += '<section class="pr-section" id="pr-lb-reviews" aria-labelledby="pr-lb-rev-h"><div class="pr-section__head">' +
        '<div class="pr-lbrev__score"><h3 id="pr-lb-rev-h" class="pr-display pr-section__title" style="margin-right:16px">Reviews</h3>' +
        '<span class="pr-display">' + esc(reviewCfg.rating) + '</span><span class="pr-mono" style="font-size:12px;color:var(--pr-muted)">out of 5 · ' + esc(reviewCfg.label) + '</span></div></div>';
      html += '<div class="pr-lbrev__bars" role="img" aria-label="Rating breakdown">';
      labels.forEach(function (l, i) {
        var pct = reviewCfg.dist[i] || '0';
        html += '<div class="pr-bar"><span>' + l + '★</span><span class="pr-bar__track"><span class="pr-bar__fill" style="width:' + esc(pct) + '%"></span></span><span class="pr-bar__pct">' + esc(pct) + '%</span></div>';
      });
      html += '</div><p class="pr-lbrev__empty">Full reviews live on the <a href="' + esc(p.url) + '#reviews">product page</a>.</p></section>';
    } else {
      html += '<span id="pr-lb-reviews"></span>';
    }

    lbBody.innerHTML = html;
    updateSpots(true);
  }

  function updateSpots(restart) {
    var p = products[state.handle];
    var an = p && anatomy(p);
    if (!an || !lbBody) return;
    var n = an.spots.length;
    var i = ((state.spot % n) + n) % n;
    var s = an.spots[i];
    lbBody.querySelectorAll('[data-pr-spot]').forEach(function (el) {
      el.setAttribute('aria-pressed', String(Number(el.getAttribute('data-pr-spot')) === i));
    });
    var zoom = lbBody.querySelector('[data-pr-zoom]');
    if (zoom) {
      zoom.style.transformOrigin = s.x + '% ' + s.y + '%';
      zoom.style.transform = state.locked ? 'scale(1.35)' : 'scale(1)';
    }
    var out = lbBody.querySelector('[data-pr-readout]');
    if (out) {
      out.innerHTML = '<div class="pr-up__readout" aria-live="polite"><p class="pr-up__num">' + String(i + 1).padStart(2, '0') + ' — ' + esc(s.label) + '</p>' +
        '<p class="pr-display pr-up__value">' + esc(s.value) + '</p><p class="pr-serif pr-up__note">' + esc(s.note) + '</p></div>' +
        (state.locked ? '' : '<div class="pr-up__prog" aria-hidden="true"><span></span></div>');
    }
    if (restart) startAuto();
  }

  function startAuto() {
    clearInterval(state.timer);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    state.timer = setInterval(function () {
      if (state.locked || !state.handle) return;
      state.spot += 1;
      updateSpots(false);
    }, 3400);
  }

  function open(handle, opener) {
    if (!lb || !products[handle]) return false;
    lastFocus = opener || document.activeElement;
    state.handle = handle; state.qty = 1; state.spot = 0; state.locked = false;
    render();
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    lb.scrollTop = 0;
    var c = lb.querySelector('[data-pr-lb-close]');
    if (c) c.focus();
    return true;
  }
  function close() {
    if (!lb) return;
    lb.hidden = true;
    state.handle = null;
    clearInterval(state.timer);
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pr-open]');
    if (opener && products[opener.getAttribute('data-pr-open')]) {
      e.preventDefault();
      open(opener.getAttribute('data-pr-open'), opener);
      return;
    }
    if (!lb || lb.hidden) return;
    if (e.target.closest('[data-pr-lb-close]')) { close(); return; }
    var q = e.target.closest('[data-pr-qty]');
    if (q) {
      state.qty = Math.min(10, Math.max(1, state.qty + Number(q.getAttribute('data-pr-qty'))));
      var p = products[state.handle];
      var o = lb.querySelector('[data-pr-qty-out]'); if (o) o.textContent = state.qty;
      var t = lb.querySelector('[data-pr-total]'); if (t) t.textContent = money(p.price * state.qty);
      return;
    }
    var spot = e.target.closest('[data-pr-spot]');
    if (spot) {
      var i = Number(spot.getAttribute('data-pr-spot'));
      var p2 = products[state.handle];
      var n = anatomy(p2).spots.length;
      var cur = ((state.spot % n) + n) % n;
      state.locked = !(state.locked && i === cur);
      state.spot = i;
      updateSpots(false);
      return;
    }
    if (e.target.closest('[data-pr-lb-add]')) {
      var pa = products[state.handle];
      addToCart(pa.variant, state.qty, parts(pa).name).then(function () {
        state.qty = 1;
        if (window.Rebuy && window.Rebuy.SmartCart) close(); else render();
      }).catch(function () {});
      return;
    }
    if (e.target.closest('[data-pr-lb-now]')) {
      var pn = products[state.handle];
      addToCart(pn.variant, state.qty, parts(pn).name).then(function () { window.location.href = '/checkout'; }).catch(function () {});
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lb && !lb.hidden) close();
  });

  if (lb) {
    lb.addEventListener('mousemove', function (e) {
      var stage = e.target.closest('[data-pr-stage]');
      var frame = stage && stage.querySelector('[data-pr-frame]');
      if (!frame) return;
      var r = stage.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      frame.style.transform = 'rotateY(' + (x * 12).toFixed(2) + 'deg) rotateX(' + (-y * 12).toFixed(2) + 'deg)';
    });
    lb.addEventListener('mouseout', function (e) {
      var stage = e.target.closest('[data-pr-stage]');
      if (stage && !stage.contains(e.relatedTarget)) {
        var frame = stage.querySelector('[data-pr-frame]');
        if (frame) frame.style.transform = '';
      }
    });
  }

  /* ---------- Honcho lineup: reveal on scroll + pointer parallax ---------- */
  document.querySelectorAll('[data-pr-stack]').forEach(function (stack) {
    var reveal = function () { stack.classList.add('is-in'); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { reveal(); io.disconnect(); } });
      }, { threshold: 0.25 });
      io.observe(stack);
    } else { reveal(); }
    var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!fine || reduce) return;
    stack.addEventListener('mousemove', function (e) {
      var r = stack.getBoundingClientRect();
      stack.style.setProperty('--px', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
      stack.style.setProperty('--py', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
    });
    stack.addEventListener('mouseleave', function () {
      stack.style.setProperty('--px', 0);
      stack.style.setProperty('--py', 0);
    });
  });

  /* ---------- Age gate ---------- */
  var gate = document.querySelector('[data-pr-age]');
  if (gate) {
    var ok = false;
    try { ok = window.localStorage.getItem('pr-age-ok') === '1'; } catch (e) { ok = false; }
    if (!ok) { gate.hidden = false; document.body.style.overflow = 'hidden'; var b = gate.querySelector('[data-pr-age-yes]'); if (b) b.focus(); }
    gate.addEventListener('click', function (e) {
      if (e.target.closest('[data-pr-age-yes]')) {
        try { window.localStorage.setItem('pr-age-ok', '1'); } catch (err) { /* private mode */ }
        gate.hidden = true; document.body.style.overflow = '';
      }
      if (e.target.closest('[data-pr-age-no]')) {
        window.location.href = gate.getAttribute('data-exit-url') || 'https://www.google.com';
      }
    });
  }

  refreshCart();
})();
